import { useDispatch } from 'react-redux';
import { Buttons, FlexContainer, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { showModalAction } from 'Store/modules/app/actions';
import { useTranslation } from 'Hooks/useTranslation';
import { TAX_SEASON_OVER_MODAL } from 'Constants/modals';

const EnabledFlowInfo = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.DASHBOARD);
  const dispatch = useDispatch();

  const handleClick = (): void => {
    dispatch(showModalAction({ options: { type: TAX_SEASON_OVER_MODAL } }));
  };
  return (
    <FlexContainer direction="column" align="center" justify="center" gap="dimension_16">
      <Text type="headline" color="dark" size="S_L_S" align="center">
        {t('TaxScreen.flowEnabled.title')}
      </Text>
      <Text type="paragraphs" color="dark" size="S_M_S" align="center">
        {t('TaxScreen.flowEnabled.subtitle')}
      </Text>
      <Buttons.Classic
        label={t('TaxScreen.flowEnabled.button')}
        onClick={handleClick}
        mode="primary"
        size="m"
      />
    </FlexContainer>
  );
};

export default EnabledFlowInfo;
